import { Button, Dialog } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface ConfirmRevokeAccessModalProps {
  onRevokeAccess: () => void
  close: () => void
  isOpen: boolean
  appName: string
  connectedDate?: string
}

const ConfirmRevokeAccessModal = ({
  onRevokeAccess,
  close,
  isOpen,
  appName,
  connectedDate,
}: ConfirmRevokeAccessModalProps): JSX.Element => {
  function handleSubmit(): void {
    onRevokeAccess()
    close()
  }

  return (
    <Dialog
      modal
      open={isOpen}
      onOpenChange={(open): void => {
        if (!open) close()
      }}
    >
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Are you sure?</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <Dialog.Description>
            You are about to revoke access to <strong>{appName}</strong>
            {connectedDate ? `, connected ${connectedDate}` : ''}. This will
            prevent the app from working with your Buffer account. Are you sure
            you want to continue?
          </Dialog.Description>
        </Dialog.Body>
        <Dialog.Footer>
          <Button variant="tertiary" onClick={close}>
            Cancel
          </Button>

          <Button variant="primary" onClick={handleSubmit}>
            Yes, Revoke Access
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}

export default ConfirmRevokeAccessModal
